
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 200 200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M99.804 54.948a5.836 5.836 0 013.705 1.353c5.518 2.232 9.088 7.955 8.332 14.15l-.421 3.357c.174 3.516 1.458 6.732 3.866 9.589 4.588 5.493 12.937 9.122 20.83 9h.07c3.18 0 5.8 2.567 5.835 5.774.053 3.226-2.53 5.88-5.765 5.933h-.51c-9.844 0-19.934-3.973-26.807-10.406l-1.915 15.451c17.876 13.835 34.628 35.948 35.872 63.09.21 4.227-3.058 7.805-7.277 7.998h-.37a7.636 7.636 0 01-7.628-7.296c-.914-19.546-12.058-36.088-25.03-47.619 1.12 22.188-14.553 35.497-31.258 49.206l-1.024.84a493.788 493.788 0 00-3.796 3.128 7.667 7.667 0 01-4.869 1.74 7.632 7.632 0 01-5.906-2.777 7.64 7.64 0 011.02-10.758c1.3-1.073 2.584-2.128 3.85-3.165 20.284-16.612 30.28-25.875 25.698-44.28-4.235-2.723-6.784-7.698-6.116-13.024l4.518-36.422c-11.004 4.967-19.282 15.486-22.464 29.55a5.851 5.851 0 01-5.696 4.551c-.439 0-.862-.034-1.301-.14-3.146-.722-5.132-3.85-4.412-6.997 5.661-25.04 25.278-41.826 48.81-41.826zm9.294-35.183c8.578 0 15.521 6.952 15.521 15.521 0 8.58-6.943 15.54-15.521 15.54-8.574 0-15.534-6.963-15.534-15.54 0-8.57 6.96-15.521 15.534-15.521z","fill":"currentColor","fill-rule":"nonzero"}})])
          )
        }
      }
    